module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Aprovar relatório técnico"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "540"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a aprovação do relatório técnico?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.aprovar
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.relatorio.tituloAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número",
      "value": this.relatorio.numeroAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorio.nomeCoordenador !== null) ? _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": this.relatorio.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Relatório",
      "value": 'Relatório Técnico de Extensão ' + _vm.relatorio.ordem
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [(_vm.relatorio.tipoRelatorioTecnicoItem === 1) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 2) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 3) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.relatorio.tipoRelatorioTecnicoItem) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "-"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Início:",
      "value": _vm.relatorio.dtInicialFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Fim:",
      "value": _vm.relatorio.dtFinalFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de aprovação pela Câmara de Extensão*",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.aprovacao.dataAprovacaoRelatorioExtensao),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "dataAprovacaoRelatorioExtensao", $$v)
      },
      expression: "aprovacao.dataAprovacaoRelatorioExtensao"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Processo*",
      "rules": _vm.regrasBasicas,
      "prepend-icon": "feed"
    },
    model: {
      value: (_vm.aprovacao.processo),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "processo", $$v)
      },
      expression: "aprovacao.processo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "label": "Justificativa / Observação"
    },
    model: {
      value: (_vm.aprovacao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "justificativaObservacao", $$v)
      },
      expression: "aprovacao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Aprovar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7f54d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/relatorio/aprovar.vue
// module id = 744
// module chunks = 0